import AnalyticsUtil from 'utils/AnalyticsUtil';

export const GROUPS_GA_CATEGORY = {
    groups: 'Groups Page Events',
    group: 'Group Page Events'
};

export const RESOURCE_TYPE = {
    activity: 'ACTIVITY',
    post: 'NEWS_POST'
};

export const ALL_FEED_TYPE = {
    activity: 'activityList',
    post: 'newsPosts'
};

export const FEED_TAB_TYPE = {
    ALL: 'all',
    ACTIVITIES: 'activities',
    POSTS: 'posts'
};

export const GROUP_PRIVACY = {
    PUBLIC: 'PUBLIC',
    PRIVATE: 'PRIVATE',
    INVITE: 'INVITE'
};

export const GROUP_VISIBILITY = {
    VISIBLE: 'VISIBLE',
    HIDDEN: 'HIDDEN'
};

export const GROUP_ROLE = {
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    MEMBER: 'MEMBER'
};

export const TAB_IDS = {
    FEED: 'feed',
    LEADERBOARD: 'leaderboard',
    CHALLENGES: 'challenges',
    GROUP_MEMBERS: 'members',
    // CALENDAR: 'calendar',
    COURSES: 'courses',
    ABOUT: 'about',
    SETTINGS: 'settings',
    SEARCH: 'search'
};

export const GENESIS_STATE = {
    NO_ALL_FEEDS: 'NO_ALL_FEEDS',
    NO_RECENT_ACTIVITIES: 'NO_RECENT_ACTIVITIES',
    SETTINGS_OFF: 'SETTINGS_OFF',
    NO_POSTS: 'NO_POSTS',
    POST_UNAVAILABLE: 'POST_UNAVAILABLE',
    POST_PRIVATE: 'POST_PRIVATE',
    ACTIVITY_UNAVAILABLE: 'ACTIVITY_UNAVAILABLE',
    ACTIVITY_PRIVATE: 'ACTIVITY_PRIVATE',
    NO_GROUP_DESCRIPTION: 'NO_GROUP_DESCRIPTION',
    ADMIN_NO_GROUP_DESCRIPTION: 'ADMIN_NO_GROUP_DESCRIPTION',
    GROUP_DELETED: 'GROUP_DELETED'
};

export const groupRequestErrors = {
    groupDeleted: 'groupDeleted',
    acceptRequestNoPermission: 'acceptRequestNoPermission',
    requestCancelled: 'requestCancelled',
    invitationCancelled: 'invitationCancelled',
    announcementDeleted: 'announcementDeleted'
};

export const JOIN_GROUP_TYPE = {
    joinInstantly: 'joinInstantly',
    requestJoin: 'requestJoin',
    acceptInvitation: 'acceptInvitation'
};

export const GROUP_LIST_PAGE_TAB = {
    myGroups: 'My Groups',
    findGroups: 'Find Groups',
    createGroup: 'Create a Group'
};

// Constants
export const MIN_START_SEARCH_LENGTH = 2;
export const GROUP_SEARCH_LIMIT = 15;
export const MAX_POST_IMAGE_NUMBER = 10;
export const DEFAULT_GROUP_IMAGE_NAME = 'running_01';

// Reference: https://confluence.garmin.com/pages/viewpage.action?spaceKey=DI&title=GC+Group+Overhaul+-+UX#GCGroupOverhaulUX-DefaultGroupPhotos
const groupDefaultImageActivityTypes = [
    'running',
    'roadcycling',
    'mountain_cycling',
    'swimming',
    'health_fitness',
    'golf',
    'para_sports'
];

// These size strings should match the postfix of the file names
// Reference: https://itstash.garmin.com/projects/DI-GC-WEB/repos/resource-ux/browse/htdocs/ui/web-images/group
export const groupDefaultImageSize = {
    large: 'large',
    largeSquare: 'large_square',
    medium: 'medium',
    small: 'small',
    xl: 'xl'
};

const GROUP_DEFAULT_IMAGE_ROOT_PATH = '/images/group/group_default';

/**
 * GA Events for Groups page
 */
export const pushGroupsEventsToAnalytics = (action, label) => {
    const category = GROUPS_GA_CATEGORY.groups;
    if (typeof label === 'string' && label.length > 0) {
        AnalyticsUtil.push({
            event: 'track_event',
            category,
            action,
            label
        });
    } else {
        AnalyticsUtil.push({
            event: 'track_event',
            category,
            action
        });
    }
};

/**
 * GA Events for Group page
 */
export const pushGroupEventsToAnalytics = (action, label) => {
    const category = GROUPS_GA_CATEGORY.group;
    if (typeof label === 'string' && label.length > 0) {
        AnalyticsUtil.push({
            event: 'track_event',
            category,
            action,
            label
        });
    } else {
        AnalyticsUtil.push({
            event: 'track_event',
            category,
            action
        });
    }
};

/**
 * GA Events for Group Feed
 */
export const pushGroupFeedEventsToAnalytics = (label) => {
    pushGroupEventsToAnalytics('Feed Tab Actions', label);
};

export const getGroupDefaultImages = () => {
    let types = groupDefaultImageActivityTypes;
    return types.map((type) => {
        const name = `${type}_01`;
        const src = `${GROUP_DEFAULT_IMAGE_ROOT_PATH}_${name}_large.png`;
        return {
            src,
            name
        };
    });
};

const validateGroupImageName = (imageName) => {
    if (!imageName) return false;

    const separatorIndex = imageName.lastIndexOf('_');
    const groupActivityType = imageName.substring(0, separatorIndex);
    const imageIndex = imageName.substring(separatorIndex + 1);
    return groupDefaultImageActivityTypes.includes(groupActivityType) && imageIndex === '01';
};

/**
 *
 * @param {string} imageName
 * @param {string} size
 */
export const getGroupDefaultImageUrl = (imageName, size = groupDefaultImageSize.large) => {
    let nameToDisplay = DEFAULT_GROUP_IMAGE_NAME;
    if (validateGroupImageName(imageName)) {
        nameToDisplay = imageName;
    }
    return `${GROUP_DEFAULT_IMAGE_ROOT_PATH}_${nameToDisplay}_${size}.png`;
};
